export interface ActiveAntePostBasedMyBetPart {
  eventTypeId: EventType;
  marketType: 'ANTEPOST_WIN';
  deadHeatWinDeductions?: number;
  deadHeatEachwayDeductions?: number;
  eachwayFactor?: Fraction;
  eachwayPlaces?: number;
  eventDescription?: string;
  eventId?: string;
  eventMarketTemplateDescription?: string;
  marketId?: MarketId;
  rule4Deductions?: number;
  selectionId?: SelectionId;
  selectionName?: string;
  sportId?: string;
  startTime?: string;
  priceType?: PriceType;
  handicap?: Handicap;
  inPlay: boolean;
  isMarketAvailable?: boolean;
  isStarSubEnabled?: boolean;
  marketLevels?: MarketLevels;
  odds?: Odds;
  outcomeDefinitionExp?: OutcomeDefinitionExp;
  venue?: string;
  enrichedParticipants?: EnrichedParticipants;
  eventSlug: string;
  eventTypeSlug: string;
}

export interface ActiveEventBasedMyBetPart {
  competitionId: CompetitionId;
  competitionSlug: string;
  enrichedParticipants?: EnrichedParticipants;
  eventId: string;
  eventSlug: string;
  eventTypeId: EventType;
  eventTypeSlug: string;
  hasLiveDataAvailable: boolean;
  hasLiveStreamAvailable: boolean;
  handicap?: Handicap;
  inPlay: boolean;
  isMarketAvailable?: boolean;
  isStarSubEnabled?: boolean;
  marketLevels?: MarketLevels;
  odds?: Odds;
  outcomeDefinitionExp?: OutcomeDefinitionExp;
  venue?: string;
  deadHeatWinDeductions?: number;
  deadHeatEachwayDeductions?: number;
  eachwayFactor?: Fraction;
  eachwayPlaces?: number;
  eventDescription?: string;
  eventMarketTemplateDescription?: string;
  marketId?: MarketId;
  rule4Deductions?: number;
  selectionId?: SelectionId;
  selectionName?: string;
  sportId?: string;
  startTime?: string;
  marketType?: MarketType;
  priceType?: PriceType;
}

export interface ActiveMeetingBasedMyBetPart {
  eventTypeId: MeetingBasedEventTypeId;
  eventTypeSlug: string;
  meetingId: MeetingId;
  raceId: RaceId;
  venue: string;
  venueSlug: string;
  handicap?: Handicap;
  inPlay: boolean;
  isMarketAvailable?: boolean;
  isStarSubEnabled?: boolean;
  marketLevels?: MarketLevels;
  odds?: Odds;
  outcomeDefinitionExp?: OutcomeDefinitionExp;
  deadHeatWinDeductions?: number;
  deadHeatEachwayDeductions?: number;
  eachwayFactor?: Fraction;
  eachwayPlaces?: number;
  eventDescription?: string;
  eventId?: string;
  eventMarketTemplateDescription?: string;
  marketId?: MarketId;
  rule4Deductions?: number;
  selectionId?: SelectionId;
  selectionName?: string;
  sportId?: string;
  startTime?: string;
  marketType?: MarketType;
  priceType?: PriceType;
}

export interface AllMarketGroup {
  templates: MarketTemplate[];
  type: 'ALL_MARKETS';
  allMarkets: true;
}

export interface AmericanOdds {
  americanOdds: number;
  americanOddsInt: number;
}

export interface AnimalRacingLandingPageEndpointResponse {
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  markets: Record<string, MeetingBasedMarketView>;
  meetings: Record<string, MeetingView>;
  races: Record<string, RaceView>;
  popularAccumulators: PopularAccumulatorsConfig[];
}

export type AnimalRacingLandingPageHandlerHandlerConfig = any;

export type AnimalRacingLandingPageHandlerResponseBody = AnimalRacingLandingPageEndpointResponse;

export interface AnimalRacingSpecialsPageEndpointResponse {
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  markets: Record<string, MarketView>;
  events: Record<string, MeetingBasedEventView>;
  animalRacingSpecials: (TemplateView[] | TemplateView[][])[];
}

export type AnimalRacingSpecialsPageHandlerHandlerConfig = any;

export type AnimalRacingSpecialsPageHandlerResponseBody = AnimalRacingSpecialsPageEndpointResponse;

export type AntePostEventsHandlerHandlerConfig = any;

export type AntePostEventsHandlerResponseBody = AntePostEventsView;

export interface AntePostEventsTemplateView {
  template: {
    marketId: MarketId;
    templateId: 'LINK';
  };
}

export interface AntePostEventsView {
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  markets: Record<string, MarketView>;
  events: Record<string, MeetingBasedEventView>;
  templateGroups: (AntePostEventsTemplateView[][] | AntePostEventsTemplateView[])[];
}

export type AntePostMarketHandlerHandlerConfig = any;

export type AntePostMarketHandlerResponseBody = AntePostMarketView;

export interface AntePostMarketView {
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  markets: Record<string, MarketView>;
  events: Record<string, MeetingBasedEventView>;
  templates: TemplateView[];
}

export interface APIGatewayEventClientCertificate {
  clientCertPem: string;
  serialNumber: string;
  subjectDN: string;
  issuerDN: string;
  validity: {
    notAfter: string;
    notBefore: string;
  };
}

export interface APIGatewayEventIdentity {
  accessKey: string | null;
  accountId: string | null;
  apiKey: string | null;
  apiKeyId: string | null;
  caller: string | null;
  clientCert: APIGatewayEventClientCertificate | null;
  cognitoAuthenticationProvider: string | null;
  cognitoAuthenticationType: string | null;
  cognitoIdentityId: string | null;
  cognitoIdentityPoolId: string | null;
  principalOrgId: string | null;
  sourceIp: string;
  user: string | null;
  userAgent: string | null;
  userArn: string | null;
}

export interface APIGatewayEventRequestContextWithAuthorizerAPIGatewayEventDefaultAuthorizerContext {
  accountId: string;
  apiId: string;
  authorizer?: object | null;
  connectedAt?: number;
  connectionId?: string;
  domainName?: string;
  domainPrefix?: string;
  eventType?: string;
  extendedRequestId?: string;
  protocol: string;
  httpMethod: string;
  identity: APIGatewayEventIdentity;
  messageDirection?: string;
  messageId?: string | null;
  path: string;
  stage: string;
  requestId: string;
  requestTime?: string;
  requestTimeEpoch: number;
  resourceId: string;
  resourcePath: string;
  routeKey?: string;
}

/** Works with Lambda Proxy Integration for Rest API or HTTP API integration Payload Format version 1.0 */
export type APIGatewayProxyEvent = APIGatewayProxyEventBaseAPIGatewayEventDefaultAuthorizerContext;

export interface APIGatewayProxyEventBaseAPIGatewayEventDefaultAuthorizerContext {
  body: string | null;
  headers: APIGatewayProxyEventHeaders;
  multiValueHeaders: APIGatewayProxyEventMultiValueHeaders;
  httpMethod: string;
  isBase64Encoded: boolean;
  path: string;
  pathParameters: APIGatewayProxyEventPathParameters | null;
  queryStringParameters: APIGatewayProxyEventQueryStringParameters | null;
  multiValueQueryStringParameters: APIGatewayProxyEventMultiValueQueryStringParameters | null;
  stageVariables: APIGatewayProxyEventStageVariables | null;
  requestContext: APIGatewayEventRequestContextWithAuthorizerAPIGatewayEventDefaultAuthorizerContext;
  resource: string;
}

export type APIGatewayProxyEventHeaders = Record<string, string | any>;

export type APIGatewayProxyEventMultiValueHeaders = Record<string, string[] | any>;

export type APIGatewayProxyEventMultiValueQueryStringParameters = Record<string, string[] | any>;

export type APIGatewayProxyEventPathParameters = Record<string, string | any>;

export type APIGatewayProxyEventQueryStringParameters = Record<string, string | any>;

export type APIGatewayProxyEventStageVariables = Record<string, string | any>;

export interface AvailableCashoutQuote {
  betDelay: number;
  betId: string;
  cashOutToken: string;
  freeSize: number;
  marketStatus: Record<string, MarketStatus>;
  originalPotentialWin: number;
  partialCashout: {
    originalRemainingPotentialReturn: number;
    partialCashoutQuote: number;
    remainingPotentialReturn: number;
    remainingStake: number;
    remainingStakePerLine: number;
  }[];
  potentialWin: number;
  quote: number;
  quoteStatus: 'AVAILABLE';
  refreshRate: number;
  stake: number;
}

export interface AzEndpointResponse {
  data: MappedAz;
}

export type AzHandlerHandlerConfig = any;

export type AzHandlerResponseBody = AzEndpointResponse;

export interface BannerMarket {
  inPlay: boolean;
  legTypes: LegTypes;
  marketId: string;
  marketLevels?: MarketLevels;
  marketName: string;
  marketStatus: MarketStatus;
  runners: Runners;
  turnInPlayEnabled: boolean;
}

export interface BaseMeeting {
  id: MeetingId;
  nextRaceId: RaceId;
  venue: string;
  venueSlug: string;
}

export interface BaseMyBetPart {
  handicap?: Handicap;
  inPlay: boolean;
  isMarketAvailable?: boolean;
  isStarSubEnabled?: boolean;
  marketLevels?: MarketLevels;
  odds?: Odds;
  outcomeDefinitionExp?: OutcomeDefinitionExp;
  venue?: string;
  deadHeatWinDeductions?: number;
  deadHeatEachwayDeductions?: number;
  eachwayFactor?: Fraction;
  eachwayPlaces?: number;
  eventDescription?: string;
  eventId?: string;
  eventMarketTemplateDescription?: string;
  marketId?: MarketId;
  rule4Deductions?: number;
  selectionId?: SelectionId;
  selectionName?: string;
  sportId?: string;
  startTime?: string;
  marketType?: MarketType;
  priceType?: PriceType;
}

export interface BaseRace {
  id: RaceId;
  meetingId: MeetingId;
  startTime: string;
  status?: RaceStatus;
}

export enum BetLegType {
  SS = 'SS',
  SF = 'SF',
  RF = 'RF',
  CF = 'CF',
  TC = 'TC',
  CT = 'CT',
  SC = 'SC',
  MH = 'MH',
  WH = 'WH',
  SL = 'SL',
  HL = 'HL',
  FW = 'FW',
  LW = 'LW',
  AW = 'AW'
}

export enum BetType {
  CANADIAN = 'CANADIAN',
  DOUBLE = 'DOUBLE',
  EIGHTEENFOLD = 'EIGHTEENFOLD',
  EIGHTFOLD = 'EIGHTFOLD',
  ELEVENFOLD = 'ELEVENFOLD',
  FIFTEENFOLD = 'FIFTEENFOLD',
  FIVEFOLD = 'FIVEFOLD',
  FOURFOLD = 'FOURFOLD',
  FOURTEENFOLD = 'FOURTEENFOLD',
  GOLIATH = 'GOLIATH',
  HEINZ = 'HEINZ',
  LUCKY15 = 'LUCKY_15',
  LUCKY31 = 'LUCKY_31',
  LUCKY63 = 'LUCKY_63',
  NINEFOLD = 'NINEFOLD',
  NINETEENFOLD = 'NINETEENFOLD',
  PATENT = 'PATENT',
  SEVENFOLD = 'SEVENFOLD',
  SEVENTEENFOLD = 'SEVENTEENFOLD',
  SINGLE = 'SINGLE',
  SIXFOLD = 'SIXFOLD',
  SIXTEENFOLD = 'SIXTEENFOLD',
  SUPER_HEINZ = 'SUPER_HEINZ',
  TENFOLD = 'TENFOLD',
  THIRTEENFOLD = 'THIRTEENFOLD',
  TREBLE = 'TREBLE',
  TRIXIE = 'TRIXIE',
  TWELVEFOLD = 'TWELVEFOLD',
  TWENTYFIVEFOLD = 'TWENTYFIVEFOLD',
  TWENTYFOLD = 'TWENTYFOLD',
  TWENTYFOURFOLD = 'TWENTYFOURFOLD',
  TWENTYONEFOLD = 'TWENTYONEFOLD',
  TWENTYTHREEFOLD = 'TWENTYTHREEFOLD',
  TWENTYTWOFOLD = 'TWENTYTWOFOLD',
  YANKEE = 'YANKEE'
}

export interface BreadcrumbsEndpointResponse {
  data: {
    text?: string;
  };
}

export type BreadcrumbsHandlerHandlerConfig = any;

export type BreadcrumbsHandlerResponseBody = BreadcrumbsEndpointResponse;

export type BrowseInPlayForSportHandlerHandlerConfig = any;

export interface BrowseInPlayForSportHandlerResponseBody {
  data: BrowseInPlayTemplatesView;
}

export type BrowseInPlayHandlerHandlerConfig = any;

export interface BrowseInPlayHandlerResponseBody {
  data: BrowseInPlayTemplatesView;
}

export interface BrowseInPlayTemplatesView {
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  markets: Record<string, MarketView>;
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  groups: TemplateView[][][];
  tabs: MappedInPlayTabs;
}

export type BvpPassthroughHandlerHandlerConfig = any;

export type BvpPassthroughHandlerQueryStringParameters = any;

export type BvpPassthroughHandlerQueryStringParametersType =
  ConvertedBvpPassthroughQueryStringParameterType;

export type BvpPassthroughHandlerRequestBody = Record<string, any> | string;

export type BvpPassthroughHandlerResponseBody = any;

export type BvpPassthroughLegacyHandlerHandlerConfig = any;

export type BvpPassthroughLegacyHandlerRequestBody = Record<string, any> | string;

export type BvpPassthroughLegacyHandlerResponseBody = any;

export type CashoutQuote =
  | AvailableCashoutQuote
  | SuspendedCashoutQuote
  | UnavailableCashoutQuote
  | PendingCashoutQuote;

export type CmsBannerHomeHandlerHandlerConfig = any;

export type CmsBannerHomeHandlerResponseBody = CmsBannerResponseBody;

export interface CmsBannerResponseBody {
  data: (StaticBanner | DynamicBanner)[];
}

export type CmsBannerSportHandlerHandlerConfig = any;

export type CmsBannerSportHandlerResponseBody = CmsBannerResponseBody;

export interface CompetitionDynamicBanner {
  eventType: {
    eventTypeId: EventType;
    eventTypeName: string;
    eventTypeSlug: string;
  };
  id: string;
  image: string;
  template: 'STANDARD' | 'ODDS_BOOST' | 'BET_BUILDER' | 'REQUEST_A_BET';
  type: 'DYNAMIC_BANNER';
  weight: number;
  bannerType: 'COMPETITION';
  competition: {
    competitionId: CompetitionId;
    competitionName: string;
    competitionSlug: string;
  };
}

export type CompetitionEventsHandlerHandlerConfig = any;

export interface CompetitionEventsHandlerResponseBody {
  data: CompetitionEventsTemplatesView | NoEventTypeOrCompetitionResponse;
}

export interface CompetitionEventsTemplatesView {
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  markets: Record<string, MarketView>;
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  hasInPlayMarkets: boolean;
  showOutrights: boolean;
  templateGroups: TemplateView[][][];
}

export type CompetitionId = number;

export interface CompetitionLink {
  eventTypeId: EventType;
  eventTypeSlug: string;
  text: string;
  type: 'COMPETITION';
  competitionId: CompetitionId;
  competitionSlug: string;
}

export type CompetitionMatchesHandlerHandlerConfig = any;

export interface CompetitionMatchesHandlerResponseBody {
  data: CompetitionMatchesMarketTemplatesView;
}

export interface CompetitionMatchesMarketTemplatesView {
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  markets: Record<string, MarketView>;
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  competitionName: string;
  templateGroups: MarketTemplate[][][];
}

export type CompetitionOutrightsHandlerHandlerConfig = any;

export interface CompetitionOutrightsHandlerResponseBody {
  data: MappedCompetitionOutrights;
}

export interface CompetitionsPageEndpointResponse {
  competitions: Record<string, CompetitionView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  allCompetitionIds: CompetitionId[];
  groups: {
    competitionIds: CompetitionId[];
    name: string;
  }[];
}

export type CompetitionsPageHandlerHandlerConfig = any;

export type CompetitionsPageHandlerResponseBody = CompetitionsPageEndpointResponse;

export interface CompetitionsQuickSwitcherData {
  competitions: Record<string, CompetitionView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  _type: 'COMPETITIONS';
  items: NonEmptyArrayCompetitionId;
  title: string;
}

export type CompetitionsV2HandlerHandlerConfig = any;

export type CompetitionsV2HandlerResponseBody = CompetitionsView;

export interface CompetitionsView {
  allCompetitionIds: CompetitionId[];
  competitions: Record<string, CompetitionView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  groups: {
    competitionIds: CompetitionId[];
    name: string;
  }[];
}

export interface CompetitionView {
  competitionId: CompetitionId;
  competitionName: string;
  competitionSlug: string;
  eventTypeId: EventType;
  logoUrl?: string;
  oddsBoostCount: number;
}

export type CompoundMarketTemplate =
  | MarketLevelTableCompoundMarketTemplate
  | EventLevelTableCompoundMarketTemplate;

export interface CompoundMarketTemplateConfig {
  termsAndConditions?: string;
  title: string;
}

export type ConvertedBvpPassthroughQueryStringParameterType =
  ConvertValueToStringinterface133263007618751957133263007602796;

export type ConvertedMatchFilterQueryStringParameterType =
  ConvertValueToStringinterface87312870635044387312870601157;

export type ConvertedMetaAnimalRaceQueryStringParameterType =
  ConvertValueToStringinterface96286392833445696286392801189;

export type ConvertedMetaCompetitionQueryStringParameterType =
  ConvertValueToStringinterface1411536347330445141153634701183;

export type ConvertedMetaEventQueryStringParameterType =
  ConvertValueToStringinterface1213297502337487121329750201105;

export type ConvertedMetaEventTypeQueryStringParameterType =
  ConvertValueToStringinterface180325504931339218032550490987;

export type ConvertedMetaMarketQueryStringParameterType =
  ConvertValueToStringinterface55405040632342155405040601010;

export type ConvertedMyBetsQueryStringParameterType = ConvertValueToStringSearchBetsQuery;

export type ConvertedOddsBoostQueryStringParameterType =
  ConvertValueToStringinterface8488396842753428488396840964;

export interface ConvertValueToStringinterface1213297502337487121329750201105 {
  competitionId: string;
  eventId: string;
  eventTypeId: string;
  marketGroup: string;
}

export interface ConvertValueToStringinterface133263007618751957133263007602796 {
  contentType?: string;
}

export interface ConvertValueToStringinterface1411536347330445141153634701183 {
  competitionId?: string;
  eventTypeId?: string;
}

export interface ConvertValueToStringinterface180325504931339218032550490987 {
  eventTypeId: string;
}

export interface ConvertValueToStringinterface55405040632342155405040601010 {
  eventTypeId: string;
  marketId: string;
}

export interface ConvertValueToStringinterface8488396842753428488396840964 {
  limit?: string;
}

export interface ConvertValueToStringinterface87312870635044387312870601157 {
  duration?: string;
  market?: string;
}

export interface ConvertValueToStringinterface96286392833445696286392801189 {
  eventTypeId: string;
  meetingId: string;
  raceId: string;
}

export interface ConvertValueToStringSearchBetsQuery {
  betIds?: string;
  eventIds?: string;
  fromRecord?: string;
  includeOutcomeDefinitions?: string;
  isSettled?: string;
  locale?: string;
  marketIds?: string;
  placedAfter?: string;
  placedBefore?: string;
  queryTypes?: string;
  settledAfter?: string;
  settledBefore?: string;
  sortDir?: string;
  sortParam?: string;
  toRecord?: string;
}

export type CountryCode = string;

export interface CuratedMarketGroup {
  templates: MarketTemplate[];
  type: 'CURATED' | 'BET_BUILDER';
  isSgm: boolean;
  name: string;
  slug: string;
  trackingName?: string;
}

export enum Currency {
  ARS = 'ARS',
  AUD = 'AUD',
  BYR = 'BYR',
  BRL = 'BRL',
  GBP = 'GBP',
  BGN = 'BGN',
  CAD = 'CAD',
  CLP = 'CLP',
  CNY = 'CNY',
  COP = 'COP',
  HRK = 'HRK',
  CZK = 'CZK',
  DKK = 'DKK',
  EEK = 'EEK',
  EUR = 'EUR',
  HUF = 'HUF',
  ISK = 'ISK',
  INR = 'INR',
  JPY = 'JPY',
  KZT = 'KZT',
  LVL = 'LVL',
  LTL = 'LTL',
  MXN = 'MXN',
  MDL = 'MDL',
  MNT = 'MNT',
  TWD = 'TWD',
  NZD = 'NZD',
  NOK = 'NOK',
  PYG = 'PYG',
  PEN = 'PEN',
  PHP = 'PHP',
  PFF = 'PFF',
  PLN = 'PLN',
  RON = 'RON',
  RUB = 'RUB',
  RSD = 'RSD',
  SKK = 'SKK',
  ZAR = 'ZAR',
  SEK = 'SEK',
  CHF = 'CHF',
  THB = 'THB',
  USD = 'USD',
  UAH = 'UAH',
  UYU = 'UYU'
}

export interface DecimalOdds {
  decimalOdds: number;
}

export interface DistanceFragment {
  furlongs: number;
  miles: number;
  totalFurlongs: number;
  totalMeters: number;
  yards: number;
}

export enum Duration {
  Type3H = '3H',
  Type12H = '12H',
  Type24H = '24H',
  Type4D = '4D'
}

export enum DurationId {
  Type3H = '3h',
  Type12H = '12h',
  Type24H = '24h',
  Type48H = '48h',
  Type4D = '4d'
}

export type DynamicBanner =
  | EventTypeDynamicBanner
  | CompetitionDynamicBanner
  | EventDynamicBanner
  | MarketDynamicBanner;

export type EchoEndpointHandlerHandlerConfig = any;

export interface EchoEndpointHandlerResponseBody {
  /** Works with Lambda Proxy Integration for Rest API or HTTP API integration Payload Format version 1.0 */
  event: APIGatewayProxyEvent;
  node: {
    version: string;
  };
}

/**
 * @maxItems 2
 * @minItems 2
 */
export type EnrichedParticipants = {
  participant: string;
  type?: 'HOME' | 'AWAY';
}[];

export interface EventBasedMarketView {
  competitionId?: CompetitionId;
  eventId: EventId;
  eventTypeId: EventType;
  inPlay: boolean;
  isSgmEligible?: boolean;
  isStarSubEnabled?: boolean;
  isStartingPriceMarket: boolean;
  legTypes: LegType[];
  marketId: MarketId;
  marketLevels: MarketLevels;
  marketName: string;
  marketStatus: MarketStatus;
  marketTime: string;
  marketType: MarketType;
  meetingId?: MeetingId;
  offeredInPlay: boolean;
  placeTerms?: {
    deductionFraction: string;
    numPlaces: number;
  };
  raceId?: RaceId;
  runners: Runner[];
}

export interface EventDynamicBanner {
  competition: {
    competitionId: CompetitionId;
    competitionName: string;
    competitionSlug: string;
  };
  eventType: {
    eventTypeId: EventType;
    eventTypeName: string;
    eventTypeSlug: string;
  };
  id: string;
  image: string;
  template: 'STANDARD' | 'ODDS_BOOST' | 'BET_BUILDER' | 'REQUEST_A_BET';
  type: 'DYNAMIC_BANNER';
  weight: number;
  bannerType: 'EVENT';
  event: {
    eventId: EventId;
    eventName: string;
    eventSlug: string;
    eventStartTime: string;
  };
  slug?: string;
}

export type EventId = number;

export interface EventInfo {
  competitionName: string;
  enrichedParticipants?: EnrichedParticipants;
  eventId: EventId;
  eventTime: string;
  eventTypeId: EventType;
  hasLiveDataAvailable?: boolean;
  hasLiveStreamAvailable?: boolean;
  inPlay: boolean;
  logoUrl?: string;
  name: string;
  offeredInPlay: boolean;
}

export interface EventInfoEndpointResponse {
  data: EventInfo;
}

export type EventInfoHandlerHandlerConfig = any;

export type EventInfoHandlerResponseBody = EventInfoEndpointResponse;

export interface EventLevelCompoundMarketTemplateColumnClientConfig {
  termsAndConditions?: string;
  title: string;
  columnTitles?: Record<string, string>;
  information?: string;
  marketDirection: 'COLUMN';
  shouldCollapseRunners?: true;
  marketTypeCodes: MarketType[];
}

export enum EventLevelCompoundMarketTemplateId {
  EVENT_TABLE = 'EVENT_TABLE'
}

export enum EventLevelEventTemplateId {
  EVENT_MORE_MARKETS = 'EVENT_MORE_MARKETS'
}

export enum EventLevelMarketTemplateId {
  EVENT_ROW = 'EVENT_ROW',
  EVENT_OUTRIGHT = 'EVENT_OUTRIGHT'
}

export interface EventLevelTableCompoundMarketTemplate {
  marketIds: (MarketId | null)[];
  templateId: EventLevelCompoundMarketTemplateId;
  config: EventLevelCompoundMarketTemplateColumnClientConfig;
}

export interface EventLink {
  competitionId: CompetitionId;
  competitionSlug: string;
  eventTypeId: EventType;
  eventTypeSlug: string;
  text: string;
  type: 'EVENT';
  eventId: EventId;
  eventSlug: string;
}

export interface EventPageEndpointResponse {
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  markets: Record<string, MarketView>;
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  marketsFeature: MarketGroupsList;
}

export type EventPageHandlerHandlerConfig = any;

export type EventPageHandlerResponseBody = EventPageEndpointResponse;

export interface EventsQuickSwitcherData {
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  _type: 'EVENTS';
  items: NonEmptyArrayEventId[];
  title: string;
}

export interface EventTemplate {
  eventId: EventId;
  templateId: EventLevelEventTemplateId;
}

export type EventType =
  | 6423
  | 3988
  | 61420
  | 627555
  | 1938544
  | 7522
  | 7511
  | 998919
  | 28361979
  | 2872194
  | 998918
  | 6
  | 982477
  | 136332
  | 4
  | 300000
  | 27388198
  | 11
  | 28578623
  | 3503
  | 28608996
  | 27454571
  | 6231
  | 3088925
  | 998920
  | 15826206
  | 2152880
  | 468328
  | 7523
  | 7524
  | 678378
  | 3
  | 4339
  | 28347302
  | 7
  | 29125756
  | 8
  | 606611
  | 27589895
  | 72382
  | 315220
  | 1477
  | 5
  | 5412697
  | 2378961
  | 12
  | 28609007
  | 1
  | 10
  | 4609466
  | 6422
  | 620576
  | 2593174
  | 2
  | 27065662
  | 4726642
  | 998917
  | 2901849
  | 26420387
  | 28361982
  | 451485
  | 27105927
  | 27485048
  | 998916;

export interface EventTypeAttachment {
  name: string;
  eventTypeId: EventType;
  key: EventTypeKeyEventType;
}

export interface EventTypeDynamicBanner {
  id: string;
  image: string;
  template: 'STANDARD' | 'ODDS_BOOST' | 'BET_BUILDER' | 'REQUEST_A_BET';
  type: 'DYNAMIC_BANNER';
  weight: number;
  bannerType: 'EVENT_TYPE';
  eventType: {
    eventTypeId: EventType;
    eventTypeName: string;
    eventTypeSlug: string;
  };
}

export interface EventTypeInfo {
  eventTypeName: string;
  tabs: TabConfig[];
}

export type EventTypeInfoHandlerHandlerConfig = any;

export interface EventTypeInfoHandlerResponseBody {
  data: EventTypeInfo;
}

export type EventTypeKeyEventType = any;

export interface EventTypeLink {
  text: string;
  type: 'EVENT_TYPE';
  eventTypeId: EventType;
  eventTypeSlug: string;
}

export type EventTypeSpecialsHandlerHandlerConfig = any;

export type EventTypeSpecialsHandlerResponseBody = EventTypeSpecialsView;

export interface EventTypeSpecialsView {
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  markets: Record<string, MarketView>;
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  templateGroups: (TemplateView[] | TemplateView[][])[];
}

export interface EventTypeView {
  eventTypeId: EventType;
  eventTypeSlug: string;
  name: string;
}

export interface EventView {
  competitionId: CompetitionId;
  enrichedParticipants?: EnrichedParticipants;
  eventId: EventId;
  eventName: string;
  eventSlug: string;
  eventStartTime: string;
  eventTypeId: EventType;
  hasLiveStreamAvailable?: boolean;
  hasStarSubEnabledMarkets?: boolean;
  isInPlay: boolean;
  oddsBoostCount: number;
  participants?: Participants;
}

export interface ExtraWallet {
  amount: number;
  label?: string;
  nonRedeemableAmount?: number;
  redeemable?: boolean;
  /** ======================================== Place Bets ======================================== */
  type: WalletTypeEnum;
  walletId: ExtraWalletId;
}

export type ExtraWalletId = number;

export enum FacetKeyEVENTTYPEEventType {
  EVENTTYPE6423 = 'EVENT_TYPE:6423',
  EVENTTYPE3988 = 'EVENT_TYPE:3988',
  EVENTTYPE61420 = 'EVENT_TYPE:61420',
  EVENTTYPE627555 = 'EVENT_TYPE:627555',
  EVENTTYPE1938544 = 'EVENT_TYPE:1938544',
  EVENTTYPE7522 = 'EVENT_TYPE:7522',
  EVENTTYPE7511 = 'EVENT_TYPE:7511',
  EVENTTYPE998919 = 'EVENT_TYPE:998919',
  EVENTTYPE28361979 = 'EVENT_TYPE:28361979',
  EVENTTYPE2872194 = 'EVENT_TYPE:2872194',
  EVENTTYPE998918 = 'EVENT_TYPE:998918',
  EVENTTYPE6 = 'EVENT_TYPE:6',
  EVENTTYPE982477 = 'EVENT_TYPE:982477',
  EVENTTYPE136332 = 'EVENT_TYPE:136332',
  EVENTTYPE4 = 'EVENT_TYPE:4',
  EVENTTYPE300000 = 'EVENT_TYPE:300000',
  EVENTTYPE27388198 = 'EVENT_TYPE:27388198',
  EVENTTYPE11 = 'EVENT_TYPE:11',
  EVENTTYPE28578623 = 'EVENT_TYPE:28578623',
  EVENTTYPE3503 = 'EVENT_TYPE:3503',
  EVENTTYPE28608996 = 'EVENT_TYPE:28608996',
  EVENTTYPE27454571 = 'EVENT_TYPE:27454571',
  EVENTTYPE6231 = 'EVENT_TYPE:6231',
  EVENTTYPE3088925 = 'EVENT_TYPE:3088925',
  EVENTTYPE998920 = 'EVENT_TYPE:998920',
  EVENTTYPE15826206 = 'EVENT_TYPE:15826206',
  EVENTTYPE2152880 = 'EVENT_TYPE:2152880',
  EVENTTYPE468328 = 'EVENT_TYPE:468328',
  EVENTTYPE7523 = 'EVENT_TYPE:7523',
  EVENTTYPE7524 = 'EVENT_TYPE:7524',
  EVENTTYPE678378 = 'EVENT_TYPE:678378',
  EVENTTYPE3 = 'EVENT_TYPE:3',
  EVENTTYPE4339 = 'EVENT_TYPE:4339',
  EVENTTYPE28347302 = 'EVENT_TYPE:28347302',
  EVENTTYPE7 = 'EVENT_TYPE:7',
  EVENTTYPE29125756 = 'EVENT_TYPE:29125756',
  EVENTTYPE8 = 'EVENT_TYPE:8',
  EVENTTYPE606611 = 'EVENT_TYPE:606611',
  EVENTTYPE27589895 = 'EVENT_TYPE:27589895',
  EVENTTYPE72382 = 'EVENT_TYPE:72382',
  EVENTTYPE315220 = 'EVENT_TYPE:315220',
  EVENTTYPE1477 = 'EVENT_TYPE:1477',
  EVENTTYPE5 = 'EVENT_TYPE:5',
  EVENTTYPE5412697 = 'EVENT_TYPE:5412697',
  EVENTTYPE2378961 = 'EVENT_TYPE:2378961',
  EVENTTYPE12 = 'EVENT_TYPE:12',
  EVENTTYPE28609007 = 'EVENT_TYPE:28609007',
  EVENTTYPE1 = 'EVENT_TYPE:1',
  EVENTTYPE10 = 'EVENT_TYPE:10',
  EVENTTYPE4609466 = 'EVENT_TYPE:4609466',
  EVENTTYPE6422 = 'EVENT_TYPE:6422',
  EVENTTYPE620576 = 'EVENT_TYPE:620576',
  EVENTTYPE2593174 = 'EVENT_TYPE:2593174',
  EVENTTYPE2 = 'EVENT_TYPE:2',
  EVENTTYPE27065662 = 'EVENT_TYPE:27065662',
  EVENTTYPE4726642 = 'EVENT_TYPE:4726642',
  EVENTTYPE998917 = 'EVENT_TYPE:998917',
  EVENTTYPE2901849 = 'EVENT_TYPE:2901849',
  EVENTTYPE26420387 = 'EVENT_TYPE:26420387',
  EVENTTYPE28361982 = 'EVENT_TYPE:28361982',
  EVENTTYPE451485 = 'EVENT_TYPE:451485',
  EVENTTYPE27105927 = 'EVENT_TYPE:27105927',
  EVENTTYPE27485048 = 'EVENT_TYPE:27485048',
  EVENTTYPE998916 = 'EVENT_TYPE:998916'
}

export type FacetKeyRACERaceId = string;

export type FcqPassthroughHandlerHandlerConfig = any;

export type FcqPassthroughHandlerRequestBody = Record<string, any> | string;

export type FcqPassthroughHandlerResponseBody = any;

export enum Feature {
  SGM = 'SGM',
  SGM_MULTIPLES = 'SGM_MULTIPLES'
}

export type FeaturedFiltersHandlerHandlerConfig = any;

export interface FeaturedFiltersHandlerResponseBody {
  data: MappedFeaturedFilter[];
}

export type Features = NonEmptyArrayFeature;

export interface Fraction {
  denominator: number;
  numerator: number;
}

export interface FractionalOdds {
  denominator: number;
  numerator: number;
}

export enum Going {
  ALL_WEATHER = 'ALL_WEATHER',
  DEAD = 'DEAD',
  EASY = 'EASY',
  FAST = 'FAST',
  FIRM = 'FIRM',
  FROZEN = 'FROZEN',
  GOOD = 'GOOD',
  GOOD_FIRM = 'GOOD_FIRM',
  GOOD_SOFT = 'GOOD_SOFT',
  HARD = 'HARD',
  HEAVY = 'HEAVY',
  MUDDY = 'MUDDY',
  NORMAL = 'NORMAL',
  RAIN = 'RAIN',
  SAND = 'SAND',
  SLOPPY = 'SLOPPY',
  SLOW = 'SLOW',
  SOFT = 'SOFT',
  STANDARD = 'STANDARD',
  STD = 'STD',
  STD_FAST = 'STD_FAST',
  STD_SLOW = 'STD_SLOW',
  SYNTHETIC = 'SYNTHETIC',
  WET_FAST = 'WET_FAST',
  YIELDING = 'YIELDING'
}

export interface GridMarketTemplateConfig {
  termsAndConditions?: string;
  anyOtherScoresRunners: SelectionId[];
  runners: SelectionId[];
}

export interface GroupedTemplates {
  templates: MarketTemplate[];
  type: SubMarketGroupType;
}

export type Handicap = number;

export type HomeInPlayHandlerHandlerConfig = any;

export interface HomeInPlayHandlerResponseBody {
  data: HomeInPlayTemplatesView;
}

export interface HomeInPlayTab {
  eventTypeId: EventType;
  groups: TemplateView[][][];
  name: string;
}

export interface HomeInPlayTemplatesView {
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  markets: Record<string, MarketView>;
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  tabs: HomeInPlayTab[];
}

export enum HomePageComponentNodeName {
  CMS_BANNERS = 'CMS_BANNERS',
  FEATURED = 'FEATURED',
  IN_PLAY = 'IN_PLAY',
  NEXT_RACES = 'NEXT_RACES',
  ODDS_BOOST = 'ODDS_BOOST',
  POPULAR_ACCUMULATORS = 'POPULAR_ACCUMULATORS',
  POPULAR_BET_BUILDERS = 'POPULAR_BET_BUILDERS',
  PROMOTION = 'PROMOTION',
  SPORT_PICKER = 'SPORT_PICKER',
  UPCOMING_EVENTS = 'UPCOMING_EVENTS'
}

export interface HomePageEndpointResponse {
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  markets: Record<string, MarketView>;
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  components: HomePageComponentNodeName[];
  inPlayEvents: InPlayTab[];
  meetings: Record<string, MeetingView>;
  oddsBoosts: TemplateView[];
  popularAccumulators: PopularAccumulatorsConfig[];
  popularBetBuilders: PopularBetBuildersConfig[];
  popularSports: EventTypeLink[];
  races: Record<string, RaceView>;
  upcomingEvents: UpcomingEventsTab[];
}

export type HomePageHandlerHandlerConfig = any;

export type HomePageHandlerResponseBody = HomePageEndpointResponse;

/** ======================================== Imply Bets ======================================== */
export enum ImplyRunnerFailureCode {
  BET_TYPE_NOT_SUPPORTED = 'BET_TYPE_NOT_SUPPORTED',
  DUPLICATE_RUNNER = 'DUPLICATE_RUNNER',
  IMPOSSIBLE_SAME_MARKET_COMBINATION = 'IMPOSSIBLE_SAME_MARKET_COMBINATION',
  INVALID_COMBINATION = 'INVALID_COMBINATION',
  INVALID_GLOBAL_MARKET_ID = 'INVALID_GLOBAL_MARKET_ID',
  INVALID_LEG = 'INVALID_LEG',
  INVALID_SELECTION_ID = 'INVALID_SELECTION_ID',
  INVALID_SGM_COMBINATION = 'INVALID_SGM_COMBINATION',
  INVALID_SGM_COMBINATION_SINGLE_ODDS = 'INVALID_SGM_COMBINATION_SINGLE_ODDS',
  INVALID_TEASER_COMBINATION = 'INVALID_TEASER_COMBINATION',
  MARKET_NOT_FOUND = 'MARKET_NOT_FOUND',
  MARKET_SUSPENDED = 'MARKET_SUSPENDED',
  NOT_ELIGIBLE_SGM_SELECTION = 'NOT_ELIGIBLE_SGM_SELECTION',
  REQUESTED_HANDICAP_NOT_AVAILABLE = 'REQUESTED_HANDICAP_NOT_AVAILABLE',
  REQUESTED_PRICE_NOT_AVAILABLE = 'REQUESTED_PRICE_NOT_AVAILABLE',
  RUNNER_SUSPENDED = 'RUNNER_SUSPENDED',
  SELECTION_BLOCKED_FOR_USER_COUNTRY = 'SELECTION_BLOCKED_FOR_USER_COUNTRY',
  SELECTION_NOT_AVAILABLE_INPLAY = 'SELECTION_NOT_AVAILABLE_INPLAY',
  SELECTION_NOT_FOUND = 'SELECTION_NOT_FOUND',
  TEASER_PRICE_NOT_AVAILABLE = 'TEASER_PRICE_NOT_AVAILABLE'
}

export interface InPlayMarketTemplatesView {
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  markets: Record<string, MarketView>;
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  groups: TemplateView[][][];
}

export interface InPlayTab {
  eventTypeId: EventType;
  eventTypeName: string;
  groups: TemplateView[][][];
}

export interface InvalidSgmOpportunity {
  id: string;
  runnersIds: RunnerId[];
  numberOfLines: number;
  features: Features;
  sgmData: SgmData[];
  /** ======================================== Imply Bets ======================================== */
  failureCode: ImplyRunnerFailureCode;
  status: 'UNAVAILABLE';
  type?:
    | 'CANADIAN'
    | 'DOUBLE'
    | 'EIGHTEENFOLD'
    | 'EIGHTFOLD'
    | 'ELEVENFOLD'
    | 'FIFTEENFOLD'
    | 'FIVEFOLD'
    | 'FOURFOLD'
    | 'FOURTEENFOLD'
    | 'GOLIATH'
    | 'HEINZ'
    | 'LUCKY_15'
    | 'LUCKY_31'
    | 'LUCKY_63'
    | 'NINEFOLD'
    | 'NINETEENFOLD'
    | 'PATENT'
    | 'SEVENFOLD'
    | 'SEVENTEENFOLD'
    | 'SIXFOLD'
    | 'SIXTEENFOLD'
    | 'SUPER_HEINZ'
    | 'TENFOLD'
    | 'THIRTEENFOLD'
    | 'TREBLE'
    | 'TRIXIE'
    | 'TWELVEFOLD'
    | 'TWENTYFIVEFOLD'
    | 'TWENTYFOLD'
    | 'TWENTYFOURFOLD'
    | 'TWENTYONEFOLD'
    | 'TWENTYTHREEFOLD'
    | 'TWENTYTWOFOLD'
    | 'YANKEE';
}

export interface LandingPageEndpointResponse {
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  markets: Record<string, MarketView>;
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  inPlayEvents: TemplateView[][][][];
  popularAccumulators: PopularAccumulatorsConfig[];
  popularBetBuilders: PopularBetBuildersConfig[];
  popularCompetitions: {
    competitionId: CompetitionId;
  }[];
  popularEvents: TemplateView[];
  popularOddsBoostEvents: TemplateView[];
}

export type LandingPageHandlerHandlerConfig = any;

export type LandingPageHandlerResponseBody = LandingPageEndpointResponse;

export enum LegBetType {
  Win = 'Win',
  Place = 'Place',
  Eachway = 'Eachway'
}

export interface LegCombination {
  legGroup?: string;
  legType: LegType;
  runners?: LegRunner[];
}

export interface LegRunner {
  combinationGroup?: number;
  marketId: MarketId;
  runnerStatus?: RunnerStatus;
  selectionId: SelectionId;
  handicap?: Handicap;
}

export enum LegType {
  COMBINATION_FORECAST = 'COMBINATION_FORECAST',
  COMBINATION_TRICAST = 'COMBINATION_TRICAST',
  FORECAST = 'FORECAST',
  ONE_LINE_BET = 'ONE_LINE_BET',
  REVERSE_FORECAST = 'REVERSE_FORECAST',
  SCORECAST = 'SCORECAST',
  SIMPLE_SELECTION = 'SIMPLE_SELECTION',
  TRICAST = 'TRICAST',
  WINCAST = 'WINCAST'
}

/** @minItems 1 */
export type LegTypes = LegType[];

export type LinkItem = SportTypeLink | CompetitionLink | EventLink;

export interface LinksEndpointResponse {
  data: LinkItem[];
}

export type LinksHandlerHandlerConfig = any;

export type LinksHandlerResponseBody = LinksEndpointResponse;

export interface MappedAlternateCompetition {
  hrefLang: string;
  tokens: {
    competitionId: CompetitionId;
    competitionSlug: string;
    eventTypeId: EventType;
    eventTypeSlug: string;
  };
  url: string;
}

export interface MappedAlternateEvent {
  hrefLang: string;
  tokens: {
    competitionId: CompetitionId;
    competitionSlug: string;
    eventId: EventId;
    eventSlug: string;
    eventTypeId: EventType;
    eventTypeSlug: string;
  };
  url: string;
}

export interface MappedAlternateEventType {
  hrefLang: string;
  tokens: {
    eventTypeId: EventType;
    eventTypeSlug: string;
  };
  url: string;
}

export interface MappedAlternateMarket {
  hrefLang: string;
  tokens: {
    eventSlug: string;
    eventTypeId: EventType;
    eventTypeSlug: string;
    marketId: MarketId;
    marketSlug: string;
  };
  url: string;
}

export interface MappedAlternateRace {
  hrefLang: string;
  tokens: {
    /** This is just the time of the race with the meeting prefix removed. */
    raceId: string;
    eventTypeId: EventType;
    eventTypeSlug: string;
    meetingId: MeetingId;
    venueSlug: string;
  };
  url: string;
}

export interface MappedAnimalRaceMetaData {
  eventTypeId: EventType;
  eventTypeSlug: string;
  meetingId: MeetingId;
  raceId: RaceId;
  startTime: string;
  venue: string;
  venueSlug: string;
}

export type MappedAz = EventTypeLink[];

export interface MappedCompetitionMetaData {
  competitionId: CompetitionId;
  competitionName: string;
  competitionSlug: string;
  eventTypeId: EventType;
  eventTypeName: string;
  eventTypeSlug: string;
}

export interface MappedCompetitionOutrights {
  competitionName: string;
  eventTypeName: string;
  logoUrl?: string;
  outrights: OutrightView[];
  showEvents: boolean;
  showMatches: boolean;
}

export interface MappedEventMetaData {
  competitionId: CompetitionId;
  competitionName: string;
  competitionSlug: string;
  eventId: EventId;
  eventName: string;
  eventSlug: string;
  eventTypeId: EventType;
  eventTypeName: string;
  eventTypeSlug: string;
  marketGroup?: string;
}

export interface MappedEventTypeMetaData {
  eventTypeId: EventType;
  eventTypeName: string;
  eventTypeSlug: string;
  popularCompetitions: string;
}

export interface MappedFeaturedFilter {
  eventTypeId: EventType;
  eventTypeSlug: string;
  name: string;
  params: {
    duration: Duration;
    market: string;
  };
}

export type MappedInPlayTabs = {
  count: number;
  eventTypeId: EventType;
  eventTypeSlug: string;
  name: string;
}[];

export interface MappedMarketMetaData {
  eventSlug: string;
  eventTypeId: EventType;
  eventTypeSlug: string;
  marketId: MarketId;
  marketName: string;
  marketSlug: string;
}

export type MappedMarketsUpdates = Record<string, MarketUpdate | undefined>;

export type MappedMyBets = MyBet[];

export interface MappedNextRaces {
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  markets: Record<string, MeetingBasedMarketView>;
  meetings: Record<string, MeetingView>;
  races: Record<string, RaceView>;
  templates: Template[];
  ukIeTemplates: Template[];
}

export interface MappedPopularMetaData {
  popularEventTypes: string;
}

export interface MappedRaceMeetings {
  meetings: Record<string, BaseMeeting>;
  races: Record<string, BaseRace>;
  templateGroups: MeetingGroupWithDate[][];
}

export interface MappedRacePage {
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  markets: Record<string, MeetingBasedMarketView>;
  meetings: Record<string, MeetingView>;
  races: Record<string, RaceView>;
  groups: MarketGroupsArray;
  templates: MarketTemplate[];
  timeformRunners?: string[];
}

export interface MarketDynamicBanner {
  event: {
    eventId: EventId;
    eventName: string;
    eventSlug: string;
    eventStartTime: string;
  };
  slug?: string;
  competition: {
    competitionId: CompetitionId;
    competitionName: string;
    competitionSlug: string;
  };
  eventType: {
    eventTypeId: EventType;
    eventTypeName: string;
    eventTypeSlug: string;
  };
  id: string;
  image: string;
  template: 'STANDARD' | 'ODDS_BOOST' | 'BET_BUILDER' | 'REQUEST_A_BET';
  type: 'DYNAMIC_BANNER';
  weight: number;
  bannerType: 'MARKET';
  market: BannerMarket;
}

export interface MarketGroupAllMarkets {
  groupedTemplates?: GroupedTemplates[];
  templates: MarketTemplate[];
  type: 'ALL_MARKETS';
}

export interface MarketGroupBetBuilder {
  name: string;
  popularBetBuilders?: PopularBetBuildersConfig[];
  slug: string;
  trackingName?: string;
  groupedTemplates?: GroupedTemplates[];
  templates: MarketTemplate[];
  type: 'BET_BUILDER';
}

export interface MarketGroupCurated {
  groupedTemplates?: GroupedTemplates[];
  templates: MarketTemplate[];
  type: 'CURATED';
  name: string;
  popularBetBuilders?: PopularBetBuildersConfig[];
  slug: string;
  trackingName?: string;
}

export type MarketGroupsArray = (AllMarketGroup | CuratedMarketGroup)[] | any[];

export type MarketGroupsList =
  | (MarketGroupAllMarkets | (MarketGroupCurated | MarketGroupBetBuilder | MarketGroupStarSub))[]
  | any[];

export interface MarketGroupStarSub {
  name: string;
  popularBetBuilders?: PopularBetBuildersConfig[];
  slug: string;
  trackingName?: string;
  groupedTemplates?: GroupedTemplates[];
  templates: MarketTemplate[];
  type: 'STAR_SUB';
}

export type MarketId = string;

export enum MarketLevel {
  AVB_EVENT = 'AVB_EVENT',
  COMPETITION = 'COMPETITION',
  SUB_COMPETITION = 'SUB_COMPETITION',
  UNKNOWN = 'UNKNOWN'
}

export interface MarketLevelCompoundMarketTemplateColumnClientConfig {
  termsAndConditions?: string;
  title: string;
  columnTitles?: Record<string, string>;
  information?: string;
  marketDirection: 'COLUMN';
  shouldCollapseRunners?: true;
  marketTypeCodes: MarketType[];
}

export enum MarketLevelCompoundMarketTemplateId {
  TABLE = 'TABLE',
  GAME_LINES = 'GAME_LINES',
  PLAYER_ALTERNATIVES = 'PLAYER_ALTERNATIVES'
}

export interface MarketLevelCompoundMarketTemplatePlayerAlternativesConfig {
  termsAndConditions?: string;
  title: string;
  initialScrollStartColumn?: number;
}

export interface MarketLevelCompoundMarketTemplateRowConfig {
  termsAndConditions?: string;
  title: string;
  columnTitles: string[];
  marketDirection: 'ROW';
}

export enum MarketLevelMarketTemplateId {
  GRID = 'GRID',
  LIST = 'LIST',
  ROW = 'ROW',
  TIMED_LIST = 'TIMED_LIST',
  ODDS_BOOST = 'ODDS_BOOST',
  NAMED_LIST = 'NAMED_LIST',
  RACE_CARD = 'RACE_CARD',
  LINK = 'LINK',
  ANTE_POST_LIST = 'ANTE_POST_LIST',
  CORRECT_SCORE = 'CORRECT_SCORE',
  ALTERNATE_HANDICAP = 'ALTERNATE_HANDICAP',
  ALTERNATE_TOTAL = 'ALTERNATE_TOTAL'
}

/** @minItems 1 */
export type MarketLevels = MarketLevel[];

export interface MarketLevelTableCompoundMarketTemplate {
  marketIds: (MarketId | null)[];
  templateId: MarketLevelCompoundMarketTemplateId;
  config:
    | CompoundMarketTemplateConfig
    | MarketLevelCompoundMarketTemplateRowConfig
    | MarketLevelCompoundMarketTemplateColumnClientConfig
    | MarketLevelCompoundMarketTemplatePlayerAlternativesConfig;
}

export enum MarketStatus {
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  INACTIVE = 'INACTIVE',
  OPEN = 'OPEN',
  SUSPENDED = 'SUSPENDED'
}

export type MarketsUpdatesHandlerHandlerConfig = any;

export type MarketsUpdatesHandlerResponseBody = MappedMarketsUpdates;

export type MarketTemplate = SingleMarketTemplate | CompoundMarketTemplate;

export type MarketType = string;

export interface MarketUpdate {
  legTypes?: LegType[];
  marketId: MarketId;
  marketStatus: MarketStatus;
  runners: RunnerUpdate[];
}

export type MarketView = EventBasedMarketView | MeetingBasedMarketView;

export type MatchFilterHandlerHandlerConfig = any;

export type MatchFilterHandlerQueryStringParameters = any;

export type MatchFilterHandlerQueryStringParametersType =
  ConvertedMatchFilterQueryStringParameterType;

export type MatchFilterHandlerResponseBody = MatchFilterResponse;

export interface MatchFilterResponse {
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  markets: Record<string, MarketView>;
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  filters: TranslatedFilters;
  templateGroups: TemplateView[][][];
}

export type MeetingBasedEventTypeId = 7 | 4339;

export interface MeetingBasedEventView {
  enrichedParticipants?: EnrichedParticipants;
  eventId: EventId;
  eventName: string;
  eventSlug: string;
  eventStartTime: string;
  eventTypeId: MeetingBasedEventTypeId;
  hasLiveStreamAvailable?: boolean;
  isInPlay: boolean;
  oddsBoostCount: number;
  participants?: Participants;
}

export interface MeetingBasedMarketView {
  competitionId?: CompetitionId;
  eventId: EventId;
  eventTypeId: MeetingBasedEventTypeId;
  inPlay: boolean;
  isSgmEligible?: boolean;
  isStarSubEnabled?: boolean;
  isStartingPriceMarket: boolean;
  legTypes: LegType[];
  marketId: MarketId;
  marketLevels: MarketLevels;
  marketName: string;
  marketStatus: MarketStatus;
  marketTime: string;
  marketType: MarketType;
  meetingId: MeetingId;
  offeredInPlay: boolean;
  placeTerms?: {
    deductionFraction: string;
    numPlaces: number;
  };
  raceId: RaceId;
  runners: MeetingBasedRunner[];
}

export interface MeetingBasedRunner {
  handicap?: Handicap;
  previousWinRunnerOdds: Odds[];
  resultType?: RunnerResultType;
  runnerName: string;
  runnerStatus?: RunnerStatusMarketDetails;
  selectionId: SelectionId;
  sortPriority: number;
  winRunnerOdds?: Odds;
  comments?: string;
  daysOff?: number;
  details?: RichContentRunnerDetails;
  form?: string;
  horse?: {
    age?: number;
  };
  rating?: number;
  rating123?: number;
  ratingStars?: number;
}

export interface MeetingGroupWithDate {
  meetingIds: MeetingId[];
  name: RegionName;
  date: string;
}

export type MeetingId = string;

export interface MeetingLink {
  eventTypeId: EventType;
  eventTypeSlug: string;
  meetingId: string;
  openDate: string;
  raceId: string;
  venue: string;
  venueSlug: string;
}

export interface MeetingsQuickSwitcherData {
  meetings: Record<string, MeetingView>;
  races: Record<string, RaceView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  _type: 'MEETINGS';
  firstOffRaceId: RaceId;
  groups: RaceId[][];
  header: RegionName;
}

export interface MeetingView {
  eventTypeId: EventType;
  meetingId: MeetingId;
  venue: string;
  venueSlug: string;
}

export interface MetaAnimalRaceEndpointResponse {
  alternates: MappedAlternateRace[];
  tokens: Record<string, MappedAnimalRaceMetaData>;
}

export type MetaAnimalRaceHandlerHandlerConfig = any;

export type MetaAnimalRaceHandlerQueryStringParameters = any;

export type MetaAnimalRaceHandlerQueryStringParametersType =
  ConvertedMetaAnimalRaceQueryStringParameterType;

export type MetaAnimalRaceHandlerResponseBody = MetaAnimalRaceEndpointResponse;

export interface MetaCompetitionEndpointResponse {
  alternates: MappedAlternateCompetition[];
  tokens: Record<string, MappedCompetitionMetaData>;
}

export type MetaCompetitionHandlerHandlerConfig = any;

export type MetaCompetitionHandlerQueryStringParameters = any;

export type MetaCompetitionHandlerQueryStringParametersType =
  ConvertedMetaCompetitionQueryStringParameterType;

export type MetaCompetitionHandlerResponseBody = MetaCompetitionEndpointResponse;

export type MetaEventHandlerHandlerConfig = any;

export type MetaEventHandlerQueryStringParameters = any;

export type MetaEventHandlerQueryStringParametersType = ConvertedMetaEventQueryStringParameterType;

export interface MetaEventHandlerResponseBody {
  alternates: MappedAlternateEvent[];
  tokens: Record<string, MappedEventMetaData>;
}

export type MetaEventTypeHandlerHandlerConfig = any;

export type MetaEventTypeHandlerQueryStringParameters = any;

export type MetaEventTypeHandlerQueryStringParametersType =
  ConvertedMetaEventTypeQueryStringParameterType;

export interface MetaEventTypeHandlerResponseBody {
  alternates: MappedAlternateEventType[];
  tokens: Record<string, MappedEventTypeMetaData>;
}

export type MetaMarketHandlerHandlerConfig = any;

export type MetaMarketHandlerQueryStringParameters = any;

export type MetaMarketHandlerQueryStringParametersType =
  ConvertedMetaMarketQueryStringParameterType;

export interface MetaMarketHandlerResponseBody {
  alternates: MappedAlternateMarket[];
  tokens: Record<string, MappedMarketMetaData>;
}

export type MetaPopularHandlerHandlerConfig = any;

export type MetaPopularHandlerResponseBody = ResponsePayloadMappedPopularMetaData;

export type MultipleAvailableOpportunity =
  | {
      status: OpportunityStatus;
      applicableWallets?: ExtraWalletId[];
      betDelay: number;
      betReference?: string;
      eachWayAvailable: boolean;
      eachWayMax: number;
      hasBonusMoney?: boolean;
      id: string;
      legCombinations: LegCombination[];
      maxPayout?: number;
      maxStake: number;
      minLineStake?: number;
      minStake: number;
      minStakeIncrement: number;
      numberOfLines: number;
      placeReturnFactor?: number;
      raceId?: RaceId;
      returnFactor?: number;
      type: MultipleBetType;
      winRunnerOdds?: Odds;
      eventInPlay: boolean;
      features?: Features;
      minOdds?: Odds;
      runnersIds: RunnerId[];
    }
  | SgmOpportunity;

export enum MultipleBetType {
  CANADIAN = 'CANADIAN',
  DOUBLE = 'DOUBLE',
  EIGHTEENFOLD = 'EIGHTEENFOLD',
  EIGHTFOLD = 'EIGHTFOLD',
  ELEVENFOLD = 'ELEVENFOLD',
  FIFTEENFOLD = 'FIFTEENFOLD',
  FIVEFOLD = 'FIVEFOLD',
  FOURFOLD = 'FOURFOLD',
  FOURTEENFOLD = 'FOURTEENFOLD',
  GOLIATH = 'GOLIATH',
  HEINZ = 'HEINZ',
  LUCKY15 = 'LUCKY_15',
  LUCKY31 = 'LUCKY_31',
  LUCKY63 = 'LUCKY_63',
  NINEFOLD = 'NINEFOLD',
  NINETEENFOLD = 'NINETEENFOLD',
  PATENT = 'PATENT',
  SEVENFOLD = 'SEVENFOLD',
  SEVENTEENFOLD = 'SEVENTEENFOLD',
  SIXFOLD = 'SIXFOLD',
  SIXTEENFOLD = 'SIXTEENFOLD',
  SUPER_HEINZ = 'SUPER_HEINZ',
  TENFOLD = 'TENFOLD',
  THIRTEENFOLD = 'THIRTEENFOLD',
  TREBLE = 'TREBLE',
  TRIXIE = 'TRIXIE',
  TWELVEFOLD = 'TWELVEFOLD',
  TWENTYFIVEFOLD = 'TWENTYFIVEFOLD',
  TWENTYFOLD = 'TWENTYFOLD',
  TWENTYFOURFOLD = 'TWENTYFOURFOLD',
  TWENTYONEFOLD = 'TWENTYONEFOLD',
  TWENTYTHREEFOLD = 'TWENTYTHREEFOLD',
  TWENTYTWOFOLD = 'TWENTYTWOFOLD',
  YANKEE = 'YANKEE'
}

export interface MultipleMinOddsRestrictedOpportunity {
  applicableWallets?: ExtraWalletId[];
  betDelay: number;
  betReference?: string;
  eachWayAvailable: boolean;
  eachWayMax: number;
  hasBonusMoney?: boolean;
  id: string;
  legCombinations: LegCombination[];
  maxPayout?: number;
  maxStake: number;
  minLineStake?: number;
  minStake: number;
  minStakeIncrement: number;
  numberOfLines: number;
  placeReturnFactor?: number;
  raceId?: RaceId;
  returnFactor?: number;
  status: 'RESTRICTED';
  type: MultipleBetType;
  winRunnerOdds?: Odds;
  eventInPlay: boolean;
  features?: Features;
  minOdds: Odds;
  runnersIds: RunnerId[];
  restrictedReason: 'BELOW_MIN_ODDS';
}

export type MultipleOpportunity =
  | MultipleAvailableOpportunity
  | MultipleMinOddsRestrictedOpportunity
  | MultiplePlayMoneyRestrictedOpportunity
  | InvalidSgmOpportunity;

export interface MultiplePlayMoneyRestrictedOpportunity {
  applicableWallets?: ExtraWalletId[];
  betDelay: number;
  betReference?: string;
  eachWayAvailable: boolean;
  eachWayMax: number;
  hasBonusMoney?: boolean;
  id: string;
  legCombinations: LegCombination[];
  maxPayout?: number;
  maxStake: number;
  minLineStake?: number;
  minStake: number;
  minStakeIncrement: number;
  numberOfLines: number;
  placeReturnFactor?: number;
  raceId?: RaceId;
  returnFactor?: number;
  status: 'RESTRICTED';
  type: MultipleBetType;
  winRunnerOdds?: Odds;
  eventInPlay: boolean;
  features?: Features;
  minOdds?: Odds;
  runnersIds: RunnerId[];
  restrictedReason: 'PLAY_MONEY_NOT_SUPPORTED';
}

export interface MyBet {
  actualWin?: number;
  betId: string;
  betReceiptId: string;
  betType: BetType;
  currency: Currency;
  eachwayFactor?: Fraction;
  eachwayPlaces?: number;
  isSettled: boolean;
  isSgm?: boolean;
  legBetType: LegBetType;
  legs: MyBetLeg[];
  numLines: number;
  odds?: Odds;
  placedDate: string;
  potentialWin?: string;
  regulatorId?: string;
  result?: ResultType;
  settledDate?: string;
  sgmEvents?: MyBetSgmEvent[];
  sgmResult?: SgmResultType;
  stake?: number;
  stakePerLine?: number;
  status: string;
  walletInfo: WalletInfo;
}

export interface MyBetLeg {
  legType: BetLegType;
  parts: MyBetPart[];
  result?: ResultType;
}

export type MyBetPart =
  | BaseMyBetPart
  | ActiveEventBasedMyBetPart
  | ActiveMeetingBasedMyBetPart
  | ActiveAntePostBasedMyBetPart;

export interface MyBetSgmEvent {
  eventDescription?: string;
  eventId: string;
  eventTypeId: number;
  inPlay: boolean;
  legType: BetLegType;
  parts: (
    | {
        result?: ResultType;
        handicap?: Handicap;
        inPlay: boolean;
        isMarketAvailable?: boolean;
        isStarSubEnabled?: boolean;
        marketLevels?: MarketLevels;
        odds?: Odds;
        outcomeDefinitionExp?: OutcomeDefinitionExp;
        venue?: string;
        deadHeatWinDeductions?: number;
        deadHeatEachwayDeductions?: number;
        eachwayFactor?: Fraction;
        eachwayPlaces?: number;
        eventDescription?: string;
        eventId?: string;
        eventMarketTemplateDescription?: string;
        marketId?: MarketId;
        rule4Deductions?: number;
        selectionId?: SelectionId;
        selectionName?: string;
        sportId?: string;
        startTime?: string;
        marketType?: MarketType;
        priceType?: PriceType;
      }
    | {
        result?: ResultType;
        competitionId: CompetitionId;
        competitionSlug: string;
        enrichedParticipants?: EnrichedParticipants;
        eventId: string;
        eventSlug: string;
        eventTypeId: EventType;
        eventTypeSlug: string;
        hasLiveDataAvailable: boolean;
        hasLiveStreamAvailable: boolean;
        handicap?: Handicap;
        inPlay: boolean;
        isMarketAvailable?: boolean;
        isStarSubEnabled?: boolean;
        marketLevels?: MarketLevels;
        odds?: Odds;
        outcomeDefinitionExp?: OutcomeDefinitionExp;
        venue?: string;
        deadHeatWinDeductions?: number;
        deadHeatEachwayDeductions?: number;
        eachwayFactor?: Fraction;
        eachwayPlaces?: number;
        eventDescription?: string;
        eventMarketTemplateDescription?: string;
        marketId?: MarketId;
        rule4Deductions?: number;
        selectionId?: SelectionId;
        selectionName?: string;
        sportId?: string;
        startTime?: string;
        marketType?: MarketType;
        priceType?: PriceType;
      }
    | {
        result?: ResultType;
        eventTypeId: MeetingBasedEventTypeId;
        eventTypeSlug: string;
        meetingId: MeetingId;
        raceId: RaceId;
        venue: string;
        venueSlug: string;
        handicap?: Handicap;
        inPlay: boolean;
        isMarketAvailable?: boolean;
        isStarSubEnabled?: boolean;
        marketLevels?: MarketLevels;
        odds?: Odds;
        outcomeDefinitionExp?: OutcomeDefinitionExp;
        deadHeatWinDeductions?: number;
        deadHeatEachwayDeductions?: number;
        eachwayFactor?: Fraction;
        eachwayPlaces?: number;
        eventDescription?: string;
        eventId?: string;
        eventMarketTemplateDescription?: string;
        marketId?: MarketId;
        rule4Deductions?: number;
        selectionId?: SelectionId;
        selectionName?: string;
        sportId?: string;
        startTime?: string;
        marketType?: MarketType;
        priceType?: PriceType;
      }
    | {
        result?: ResultType;
        eventTypeId: EventType;
        marketType: 'ANTEPOST_WIN';
        deadHeatWinDeductions?: number;
        deadHeatEachwayDeductions?: number;
        eachwayFactor?: Fraction;
        eachwayPlaces?: number;
        eventDescription?: string;
        eventId?: string;
        eventMarketTemplateDescription?: string;
        marketId?: MarketId;
        rule4Deductions?: number;
        selectionId?: SelectionId;
        selectionName?: string;
        sportId?: string;
        startTime?: string;
        priceType?: PriceType;
        handicap?: Handicap;
        inPlay: boolean;
        isMarketAvailable?: boolean;
        isStarSubEnabled?: boolean;
        marketLevels?: MarketLevels;
        odds?: Odds;
        outcomeDefinitionExp?: OutcomeDefinitionExp;
        venue?: string;
        enrichedParticipants?: EnrichedParticipants;
        eventSlug: string;
        eventTypeSlug: string;
      }
  )[];
  startTime?: string;
}

export type MyBetsHandlerHandlerConfig = any;

export type MyBetsHandlerQueryStringParameters = any;

export type MyBetsHandlerQueryStringParametersType = ConvertedMyBetsQueryStringParameterType;

export type MyBetsHandlerResponseBody = MyBetsResponse;

export interface MyBetsResponse {
  accountId?: number;
  currencyCode?: string;
  localeCode?: string;
  moreAvailable?: boolean;
  numberOfMatches?: number;
  bets: MappedMyBets;
  cashoutQuotes: Record<string, CashoutQuote>;
  pollingInterval: number;
}

export type NextRacesHandlerHandlerConfig = any;

export interface NextRacesHandlerResponseBody {
  data: MappedNextRaces;
}

export interface NoEventTypeOrCompetitionResponse {
  showOutrights: boolean;
}

/** @minItems 1 */
export type NonEmptyArrayCompetitionId = CompetitionId[];

/** @minItems 1 */
export type NonEmptyArrayEventId = EventId[];

/** @minItems 1 */
export type NonEmptyArrayFeature = Feature[];

export interface Odds {
  americanDisplayOdds?: AmericanOdds;
  decimalDisplayOdds?: DecimalOdds;
  fractionalDisplayOdds?: FractionalOdds;
  trueOdds: TrueOdds;
}

export type OddsBoostHandlerHandlerConfig = any;

export type OddsBoostHandlerQueryStringParameters = any;

export type OddsBoostHandlerQueryStringParametersType = ConvertedOddsBoostQueryStringParameterType;

export interface OddsBoostHandlerResponseBody {
  data: OddsBoostMarketTemplatesView;
}

export interface OddsBoostMarketTemplatesView {
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  markets: Record<string, MarketView>;
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  groups: MarketId[][];
}

export type OpportunitiesHandlerHandlerConfig = any;

export type OpportunitiesHandlerResponseBody = OpportunitiesResponse;

export interface OpportunitiesResponse {
  dailyMaxPayoutLimit?: number;
  errorCode?: string;
  hasInvalidCombination: boolean;
  opportunities: {
    MULTIPLE: MultipleOpportunity[];
    SINGLE: SingleOpportunity[];
  };
  requiredPlacementCurrency?: Currency;
  wallets: Record<string, ExtraWallet>;
}

export enum OpportunityStatus {
  AVAILABLE = 'AVAILABLE',
  SUSPENDED = 'SUSPENDED',
  UNAVAILABLE = 'UNAVAILABLE',
  RESTRICTED = 'RESTRICTED'
}

export interface OutcomeDefinitionExp {
  outcomeDefinitionEntries?: {
    outcomeDefinition?: {
      query?: {
        outcome?: string;
        participant?: {
          id?: string;
          side?: string;
          type?: string;
        };
        periodDefinition?: {
          period?: string;
          periodStatus?: string;
        };
        sport?: string;
      };
      statsThresholdDef?: {
        comparison?: string;
        threshold?: number;
      };
    };
    type?: string;
  }[];
}

export interface OutrightMarket {
  id: MarketId;
  label: string;
  legTypes?: LegType[];
  marketStatus: MarketStatus;
  marketType: string;
  placeTerms?: PlaceTerms;
  runners: Runner[];
}

export interface OutrightView {
  eventStartTime: string;
  id: EventId;
  markets: OutrightMarket[];
  name: string;
}

/** @minItems 2 */
export type Participants = string[];

export interface PendingCashoutQuote {
  betId: string;
  freeSize: number;
  marketStatus: Record<string, MarketStatus>;
  marketStatusReason: Record<string, 'LATE_WITHDRAWAL' | 'INPLAY_COUNTRY_NOT_ELIGIBLE'>;
  originalPotentialWin: number;
  potentialWin: number;
  quoteStatus:
    | 'UNAVAILABLE'
    | 'BET_CLOSED'
    | 'NOT_ELIGIBLE'
    | 'QUOTE_TOO_LOW'
    | 'QUOTE_TOO_LOW_FREE_BET'
    | 'LEG_RESULT_PENDING'
    | 'PENDING_CASHOUT';
  quoteStatusReason: ('LATE_WITHDRAWAL' | 'INPLAY_COUNTRY_NOT_ELIGIBLE' | 'ACCOUNT_NOT_ACTIVE')[];
  refreshRate: number;
  stake: number;
}

export interface PlaceTerms {
  deductionFraction: string;
  numPlaces: number;
}

export interface PopularAccumulatorsConfig {
  count: number;
  runnerIds: RunnerId[];
  winRunnerOdds: Odds;
}

export interface PopularBetBuildersConfig {
  competitionId: CompetitionId;
  count: number;
  eventId: EventId;
  eventTypeId: EventType;
  runnersIds: RunnerId[];
  winRunnerOdds: Odds;
}

export enum PriceType {
  LIVE = 'LIVE',
  STARTING = 'STARTING',
  GUARANTEED = 'GUARANTEED',
  DIVIDEND = 'DIVIDEND'
}

export type QuickSwitcherData =
  | EventsQuickSwitcherData
  | MeetingsQuickSwitcherData
  | CompetitionsQuickSwitcherData;

export type QuickSwitcherHandlerHandlerConfig = any;

export type QuickSwitcherHandlerResponseBody = QuickSwitcherData;

export interface RaceCardMarketTemplateConfig {
  termsAndConditions?: string;
  nonRunners: SelectionId[];
  runners: SelectionId[];
  unnamedFavourites: SelectionId[];
}

export interface RaceDetailsFragment {
  distance: DistanceFragment;
  going?: Going;
  raceClass?: number;
  status?: RaceStatus;
  type?: RaceType;
}

export type RaceId = string;

export type RaceKeyRaceId = any;

export type RaceMeetingsHandlerHandlerConfig = any;

export interface RaceMeetingsHandlerResponseBody {
  data: MappedRaceMeetings;
}

export type RacePageHandlerHandlerConfig = any;

export interface RacePageHandlerResponseBody {
  data: MappedRacePage;
}

export enum RaceStatus {
  ABANDONED = 'ABANDONED',
  AT_THE_POST = 'AT_THE_POST',
  DELAYED = 'DELAYED',
  DORMANT = 'DORMANT',
  FALSE_START = 'FALSE_START',
  FINISHED = 'FINISHED',
  GOING_BEHIND = 'GOING_BEHIND',
  GOING_DOWN = 'GOING_DOWN',
  OFF = 'OFF',
  PARADING = 'PARADING',
  PHOTOGRAPH = 'PHOTOGRAPH',
  RACE_VOID = 'RACE_VOID',
  RESULT = 'RESULT',
  UNDER_ORDERS = 'UNDER_ORDERS',
  WEIGHED_IN = 'WEIGHED_IN'
}

export enum RaceType {
  BUMPER = 'BUMPER',
  CHASE = 'CHASE',
  FLAT = 'FLAT',
  HURDLE = 'HURDLE'
}

export interface RaceView {
  countryCode: CountryCode;
  eventId: EventId;
  eventTypeId: EventType;
  key: RaceKeyRaceId;
  meetingId: MeetingId;
  onTvChannels?: string[];
  raceClass?: string;
  raceId: RaceId;
  raceNumber?: string;
  raceType?: string;
  startTime: string;
  timezone?: string;
  userStartTime?: string;
  venue: string;
  videoAvailable?: boolean;
  winMarketId: MarketId;
  winMarketName?: string;
  details?: RichContentRaceDetails;
  verdict?: string;
}

export enum RegionName {
  ISPI18NUKXIRELAND = 'ISP_I18N_UK_X_IRELAND',
  ISPI18NINTERNATIONAL = 'ISP_I18N_INTERNATIONAL'
}

export interface ResponsePayloadMappedPopularMetaData {
  tokens: Record<string, MappedPopularMetaData>;
}

export enum ResultType {
  WON = 'WON',
  PLACED = 'PLACED',
  LOST = 'LOST',
  VOID = 'VOID',
  SETTLED = 'SETTLED',
  CASHED_OUT = 'CASHED_OUT'
}

export type RichContentRaceDetails = RaceDetailsFragment;

export type RichContentRunnerDetails = RunnerDetailsFragment;

export interface Runner {
  handicap?: Handicap;
  previousWinRunnerOdds: Odds[];
  resultType?: RunnerResultType;
  runnerName: string;
  runnerStatus?: RunnerStatusMarketDetails;
  selectionId: SelectionId;
  sortPriority: number;
  winRunnerOdds?: Odds;
}

export interface RunnerDetailsFragment {
  equipmentDescription?: string;
  jockeyName?: string;
  saddleCloth: string;
  silk?: any;
  trainerName?: string;
  weight?: {
    stones: string;
  };
}

export interface RunnerId {
  combinationGroup?: number;
  marketId: MarketId;
  runnerStatus?: RunnerStatus;
  selectionId: SelectionId;
}

export interface RunnerLink {
  eventTypeId: EventType;
  eventTypeSlug: string;
  meetingId: string;
  openDate: string;
  raceId: string;
  venue: string;
  venueSlug: string;
  runnerName: string;
}

export enum RunnerResultType {
  AWAY = 'AWAY',
  DRAW = 'DRAW',
  HOME = 'HOME',
  LINE = 'LINE',
  NO_GOAL = 'NO_GOAL',
  OVER = 'OVER',
  SCORE = 'SCORE',
  UNDER = 'UNDER'
}

/** @minItems 1 */
export type Runners = Runner[];

export type RunnerStatus = RunnerStatusMarketDetails | RunnerStatusMarket;

export enum RunnerStatusMarket {
  ACTIVE = 'ACTIVE',
  LOSER = 'LOSER',
  REMOVED = 'REMOVED',
  REMOVE_VACANT = 'REMOVE_VACANT',
  WINNER = 'WINNER'
}

export enum RunnerStatusMarketDetails {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  REMOVED = 'REMOVED'
}

export interface RunnerUpdate {
  handicap?: Handicap;
  previousWinRunnerOdds: Odds[];
  runnerId: RunnerId;
  runnerStatus?: RunnerStatusMarketDetails;
  winRunnerOdds?: Odds;
}

export type ScaPassthroughHandlerHandlerConfig = any;

export type ScaPassthroughHandlerRequestBody = Record<string, any> | string;

export type ScaPassthroughHandlerResponseBody = any;

export type ScoPassthroughHandlerHandlerConfig = any;

export type ScoPassthroughHandlerRequestBody = Record<string, any> | string;

export type ScoPassthroughHandlerResponseBody = any;

export interface SearchEndpointResponse {
  competitionsAndMeetings: (CompetitionLink | MeetingLink)[];
  eventTypes: Record<string, EventTypeAttachment>;
  eventsAndRunners: (SearchEventLink | RunnerLink)[];
}

export interface SearchEventLink {
  competitionId: CompetitionId;
  competitionSlug: string;
  eventTypeId: EventType;
  eventTypeSlug: string;
  text: string;
  type: 'EVENT';
  eventId: EventId;
  eventSlug: string;
  competitionName: string;
  openDate: string;
}

export type SearchHandlerHandlerConfig = any;

export type SearchHandlerResponseBody = SearchEndpointResponse;

export type SelectionId = number;

export interface SgmData {
  descriptions: SgmDescription[];
  eventId: EventId;
  eventInPlay: boolean;
  eventName: string;
  eventStartTime: string;
  eventTypeId: EventType;
}

export interface SgmDescription {
  isStarSubEnabled?: boolean;
  isValid: boolean;
  marketName: string;
  marketType: MarketType;
  runnerName: string;
}

export interface SgmOpportunity {
  applicableWallets?: ExtraWalletId[];
  betDelay: number;
  betReference?: string;
  eachWayAvailable: boolean;
  eachWayMax: number;
  hasBonusMoney?: boolean;
  id: string;
  legCombinations: LegCombination[];
  maxPayout?: number;
  maxStake: number;
  minLineStake?: number;
  minStake: number;
  minStakeIncrement: number;
  numberOfLines: number;
  placeReturnFactor?: number;
  raceId?: RaceId;
  returnFactor?: number;
  status: OpportunityStatus;
  type: MultipleBetType;
  winRunnerOdds?: Odds;
  eventInPlay: boolean;
  features: Features;
  minOdds?: Odds;
  runnersIds: RunnerId[];
  sgmData: SgmData[];
}

export enum SgmResultType {
  WON = 'WON',
  PLACED = 'PLACED',
  LOST = 'LOST',
  VOID = 'VOID'
}

export interface SingleAvailableOpportunity {
  applicableWallets?: ExtraWalletId[];
  betDelay: number;
  betReference?: string;
  eachWayAvailable: boolean;
  eachWayMax: number;
  hasBonusMoney?: boolean;
  id: string;
  legCombinations: LegCombination[];
  maxPayout?: number;
  maxStake: number;
  minLineStake?: number;
  minStake: number;
  minStakeIncrement: number;
  numberOfLines: number;
  placeReturnFactor?: number;
  raceId?: RaceId;
  returnFactor?: number;
  status: 'AVAILABLE';
  type: 'SINGLE';
  winRunnerOdds?: Odds;
  competitionId: CompetitionId;
  description: string;
  eventId: EventId;
  eventInPlay: boolean;
  eventStartTime: string;
  eventTypeId: EventType;
  handicap: Handicap;
  isStarSubEnabled?: boolean;
  isStartingPriceOpportunity: boolean;
  marketStatus: MarketStatus;
  marketTime: string;
  marketType: MarketType;
  name: string;
  placeTerms?: PlaceTerms;
  runnerId: RunnerId;
  runnerResultType?: RunnerResultType;
  venue?: string;
}

export interface SingleMarketTemplate {
  marketId: MarketId;
  templateConfig?: SingleMarketTemplateConfig;
  templateId: MarketLevelMarketTemplateId | EventLevelMarketTemplateId;
}

export type SingleMarketTemplateConfig =
  | {
      termsAndConditions?: string;
    }
  | RaceCardMarketTemplateConfig
  | GridMarketTemplateConfig;

export interface SingleMinOddsRestrictedOpportunity {
  applicableWallets?: ExtraWalletId[];
  betDelay: number;
  betReference?: string;
  eachWayAvailable: boolean;
  eachWayMax: number;
  hasBonusMoney?: boolean;
  id: string;
  legCombinations: LegCombination[];
  maxPayout?: number;
  maxStake: number;
  minLineStake?: number;
  minStake: number;
  minStakeIncrement: number;
  numberOfLines: number;
  placeReturnFactor?: number;
  raceId?: RaceId;
  returnFactor?: number;
  status: 'RESTRICTED';
  type: 'SINGLE';
  winRunnerOdds?: Odds;
  competitionId: CompetitionId;
  description: string;
  eventId: EventId;
  eventInPlay: boolean;
  eventStartTime: string;
  eventTypeId: EventType;
  handicap: Handicap;
  isStarSubEnabled?: boolean;
  isStartingPriceOpportunity: boolean;
  marketStatus: MarketStatus;
  marketTime: string;
  marketType: MarketType;
  name: string;
  placeTerms?: PlaceTerms;
  runnerId: RunnerId;
  runnerResultType?: RunnerResultType;
  venue?: string;
  restrictedReason: 'BELOW_MIN_ODDS';
  minOdds: Odds;
}

export type SingleOpportunity =
  | SingleAvailableOpportunity
  | SingleMinOddsRestrictedOpportunity
  | SinglePlayMoneyRestrictedOpportunity
  | SingleUnavailableOpportunity;

export interface SinglePlayMoneyRestrictedOpportunity {
  applicableWallets?: ExtraWalletId[];
  betDelay: number;
  betReference?: string;
  eachWayAvailable: boolean;
  eachWayMax: number;
  hasBonusMoney?: boolean;
  id: string;
  legCombinations: LegCombination[];
  maxPayout?: number;
  maxStake: number;
  minLineStake?: number;
  minStake: number;
  minStakeIncrement: number;
  numberOfLines: number;
  placeReturnFactor?: number;
  raceId?: RaceId;
  returnFactor?: number;
  status: 'RESTRICTED';
  type: 'SINGLE';
  winRunnerOdds?: Odds;
  competitionId: CompetitionId;
  description: string;
  eventId: EventId;
  eventInPlay: boolean;
  eventStartTime: string;
  eventTypeId: EventType;
  handicap: Handicap;
  isStarSubEnabled?: boolean;
  isStartingPriceOpportunity: boolean;
  marketStatus: MarketStatus;
  marketTime: string;
  marketType: MarketType;
  name: string;
  placeTerms?: PlaceTerms;
  runnerId: RunnerId;
  runnerResultType?: RunnerResultType;
  venue?: string;
  restrictedReason: 'PLAY_MONEY_NOT_SUPPORTED';
}

export interface SingleUnavailableOpportunity {
  id: string;
  eventId: EventId;
  type: 'SINGLE';
  isStarSubEnabled?: boolean;
  competitionId?: CompetitionId;
  description?: string;
  eventTypeId?: EventType;
  failureCode?: string;
  marketStatus?: MarketStatus;
  marketType?: MarketType;
  name?: string;
  runnerId: RunnerId;
  status: 'UNAVAILABLE' | 'SUSPENDED';
}

export type SpbPassthroughHandlerHandlerConfig = any;

export type SpbPassthroughHandlerRequestBody = Record<string, any> | string;

export type SpbPassthroughHandlerResponseBody = any;

export type SportInPlayHandlerHandlerConfig = any;

export interface SportInPlayHandlerResponseBody {
  data: InPlayMarketTemplatesView;
}

export interface SportTypeLink {
  text: string;
  type: 'EVENT_TYPE';
  eventTypeId: EventType;
  eventTypeSlug: string;
}

export interface StaticBanner {
  id: string;
  image: string;
  link: string;
  type: 'STATIC_BANNER';
}

export enum Status {
  Green = 'green',
  Red = 'red'
}

export type StatusHandlerHandlerConfig = any;

export interface StatusHandlerResponseBody {
  sports: Status;
  stack: string;
}

export enum SubMarketGroupType {
  ALL = 'ALL',
  PLAYER = 'PLAYER',
  RESULT = 'RESULT',
  GOALS = 'GOALS',
  CORNERS = 'CORNERS',
  CARDS = 'CARDS',
  TOUCHDOWNS = 'TOUCHDOWNS',
  PASSING = 'PASSING',
  RECEIVING = 'RECEIVING',
  RUSHING = 'RUSHING',
  PLAYER_POINTS = 'PLAYER_POINTS',
  PLAYER_REBOUNDS = 'PLAYER_REBOUNDS',
  PLAYER_ASSISTS = 'PLAYER_ASSISTS',
  PLAYER_THREES = 'PLAYER_THREES'
}

export interface SuspendedCashoutQuote {
  betId: string;
  freeSize: number;
  marketStatus: Record<string, MarketStatus>;
  originalPotentialWin: number;
  potentialWin: number;
  quoteStatus: 'SUSPENDED';
  refreshRate: number;
  stake: number;
}

export type TabConfig =
  | {
      name:
        | 'LANDING'
        | 'MATCHES'
        | 'COMPETITIONS'
        | 'SPECIALS'
        | 'FUTURE'
        | 'NEXT_RACES'
        | 'RACE_MEETINGS'
        | 'RACE_SPECIALS';
    }
  | {
      inPlayEventsCount: number;
      name: 'IN_PLAY';
    };

export interface Template {
  marketId: MarketId;
  templateId: 'RACE_CARD';
}

export interface TemplateView {
  template: MarketTemplate | EventTemplate;
}

export interface TranslatedFilters {
  durations: {
    defaultSelected?: true;
    id: DurationId;
    selected?: true;
    translationTag: string;
    translationValue: number;
  }[];
  marketTypes: {
    defaultSelected?: true;
    id: MarketType;
    selected?: true;
    translationTag: string;
  }[];
}

export interface TrueOdds {
  decimalOdds?: DecimalOdds;
  fractionalOdds?: FractionalOdds;
}

export interface UnavailableCashoutQuote {
  betId: string;
  freeSize: number;
  marketStatus: Record<string, MarketStatus>;
  quoteStatus:
    | 'UNAVAILABLE'
    | 'BET_CLOSED'
    | 'NOT_ELIGIBLE'
    | 'QUOTE_TOO_LOW'
    | 'QUOTE_TOO_LOW_FREE_BET'
    | 'LEG_RESULT_PENDING'
    | 'PENDING_CASHOUT';
}

export type UpcomingEventsHandlerHandlerConfig = any;

export interface UpcomingEventsHandlerResponseBody {
  data: UpcomingEventsTemplatesView;
}

export interface UpcomingEventsTab {
  eventTypeId: EventType;
  eventTypeName: string;
  groups: TemplateView[][][];
}

export interface UpcomingEventsTemplatesView {
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361979'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  markets: Record<string, MarketView>;
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  groups: TemplateView[][][];
}

export interface WalletInfo {
  hasBonusCash: boolean;
  hasFreeBets: boolean;
}

/** ======================================== Place Bets ======================================== */
export enum WalletTypeEnum {
  BONUSES = 'BONUSES',
  BONUS_CASH = 'BONUS_CASH',
  DEPOSITS = 'DEPOSITS',
  WAGERING = 'WAGERING',
  WINNINGS = 'WINNINGS'
}

export type MarketsUpdatesHandlerRequestBody =
  | string[]
  | {
      /** @minLength 1 */
      marketId: string;
      runnerIds?: string[];
    }[];

/** @minItems 1 */
export type OpportunitiesHandlerRequestBody = {
  eventId: number;
  legType:
    | 'COMBINATION_FORECAST'
    | 'COMBINATION_TRICAST'
    | 'FORECAST'
    | 'ONE_LINE_BET'
    | 'REVERSE_FORECAST'
    | 'SCORECAST'
    | 'SIMPLE_SELECTION'
    | 'TRICAST'
    | 'WINCAST';
  marketId: string;
  selectionId: number;
}[];
